import axios from 'axios';


export default (Vue, {appConfig}) => {
  /**
   * Get session/userinfo
   * @return {Object} session
   */
  const getSession = async () => {
    try {
      const {data: session} = await axios.get('/session');
      return session;

    } catch (error) {
      return {loggedIn: false};
    }
  };


  // https://stackoverflow.com/a/7616484
  const hashCode = (value = '') => {
    var hash = 0, i, chr;
    for (i = 0; i < value.length; i++) {
      chr = value.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr; // eslint-disable-line no-extra-parens
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  };


  /**
   * login/reg user to addon by session object
   *
   * @param {Object} session session/user object
   * @return {Object} session
   */
  const auditUser = async (session) => {
    if (session.userRoles && session.userRoles.length) {
      session.roles = session.userRoles.map((role) => {
        role = role.substring(role.indexOf('_') + 1); // remove prefix
        role = role.substring(0, 1).toLowerCase() + role.substring(1); // lowercase first letter

        return role;
      });

      if (!session.roles.includes('user')) {
        session.roles.unshift('user');
      }

    } else {
      session.roles = ['guest'];
    }

    if (session.loggedIn && appConfig.features.userManagement) {
      const {db} = Vue;

      session = await Promise((resolve, reject) => {
        db.get(session.userId, '', 'users')
            .then((userData) => resolve(userData)) // get user from db
            .catch(async (error) => {
              if (error.status === 404) { // set user in db if not found
                await db.post(session, {}, 'users');
                await db.push('users');
                return resolve(session);
              }
              reject(error);
            });
      });
    }

    if (session.loggedIn) {
      Vue.store.dispatch('session/login', session);
      localStorage.setItem('accountId', hashCode(session.accountId));

    } else {
      Vue.store.dispatch('session/logout', session);
      localStorage.removeItem('accountId');
    }


    return session;
  };


  let verifying = null;
  let verifyTimeout = null;


  /**
   * Verify/check user session
   */
  const verifyUser = async () => {
    if (verifying) {
      return await verifying;
    }

    return verifying = new Promise(async (resolve, reject) => {
      clearTimeout(verifyTimeout);

      let session;
      try {
        session = await getSession();
        await auditUser(session);

      } catch (error) {
        verifying = null;
        return reject(error);
      }

      if (session.loggedIn) {
        // Verify user/session again after 20 minutes.
        verifyTimeout = setTimeout(() => verifyUser(), 1200000);

      } else if (session.referrer === 'informiertApp') {
        window.ReactNativeWebView.postMessage('forceClose');
      }

      verifying = null;
      resolve(session);
    });
  };


  // Verify user session
  verifyUser();


  // Listen for accountId changes among other tabs.
  window.addEventListener('storage', ({key}) => {
    if (key === 'accountId') {
      verifyUser();
    }
  });


  // Export functions
  const publicFunctions = {getSession, verifyUser};

  Vue.auth = publicFunctions;

  return publicFunctions;
};
